import { render, staticRenderFns } from "./vueDeleteDialog.vue?vue&type=template&id=55d4490e&scoped=true&"
import script from "./vueDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./vueDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./vueDeleteDialog.vue?vue&type=style&index=0&id=55d4490e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4490e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
